import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { customerService } from "../../services/CustomerService";
import { useNavigate } from "react-router-dom";

export default function CollectionsPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [globalFilter, setGlobalFilter] = useState("");
  const toast = useRef(null);
  const navigate = useNavigate();

  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });
  const [endDate, setEndDate] = useState(new Date());
  const [paymentMethod, setPaymentMethod] = useState(null);

  const paymentMethodOptions = [
    { label: "Hepsi", value: null },
    { label: "Sadece Tahsilatlar", value: "PAYMENT" },
    { label: "Sadece Bakiye Düzeltmeler", value: "ADJUSTMENT" },
    { label: "Nakit", value: "Nakit" },
    { label: "Kredi Kartı", value: "KrediKarti" },
    { label: "Havale", value: "Havale" },
    { label: "EFT", value: "EFT" },
    { label: "Çek", value: "Çek" },
    { label: "Senet", value: "Senet" },
  ];

  useEffect(() => {
    fetchCollections();
  }, []);

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
  };

  const fetchCollections = async () => {
    try {
      setLoading(true);
      const params = {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        paymentMethod: paymentMethod
      };
      const res = await customerService.getAllCollections(params);
      setCollections(res.data || []);
    } catch (err) {
      toast.current.show({ severity: "error", summary: "Hata", detail: "Tahsilatlar yüklenirken hata oluştu" });
    } finally {
      setLoading(false);
    }
  };

  const header = (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="bg-emerald-600 p-4 rounded-xl shadow-lg shadow-emerald-600/20">
            <i className="pi pi-money-bill text-white text-xl"></i>
          </div>
          <div>
            <h1 className="text-xl font-black text-slate-800 m-0">Tahsilat İşlemleri</h1>
            <p className="text-xs text-slate-500 font-medium">Tüm müşterilerden alınan ödemelerin listesi</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="p-input-icon-left w-full md:w-72">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={(e) => setGlobalFilter(e.target.value)}
              placeholder="Ara..."
              className="w-full rounded-xl border-slate-200"
            />
          </span>
          <Button
            icon="pi pi-refresh"
            className="p-button-text p-button-secondary rounded-xl hover:bg-slate-100"
            onClick={fetchCollections}
            tooltip="Yenile"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 bg-slate-50 p-4 rounded-2xl border border-slate-100 items-end">
        <div className="md:col-span-3 flex flex-col gap-1.5">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-wider ml-1">Başlangıç Tarihi</label>
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate(e.value)}
            showIcon
            dateFormat="dd.mm.yy"
            className="w-full"
            inputClassName="rounded-xl border-slate-200 py-2.5 font-bold text-sm"
          />
        </div>
        <div className="md:col-span-3 flex flex-col gap-1.5">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-wider ml-1">Bitiş Tarihi</label>
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate(e.value)}
            showIcon
            dateFormat="dd.mm.yy"
            className="w-full"
            inputClassName="rounded-xl border-slate-200 py-2.5 font-bold text-sm"
          />
        </div>
        <div className="md:col-span-4 flex flex-col gap-1.5">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-wider ml-1">İşlem Tipi / Ödeme Yöntemi</label>
          <Dropdown
            value={paymentMethod}
            options={paymentMethodOptions}
            onChange={(e) => setPaymentMethod(e.value)}
            placeholder="Ödeme yöntemi seçin"
            className="w-full rounded-xl border-slate-200 font-bold text-sm h-[42px] flex items-center"
          />
        </div>
        <div className="md:col-span-2">
            <Button
                label="ARA"
                icon="pi pi-search"
                className="w-full !bg-slate-800 border-none hover:!bg-slate-900 rounded-xl font-black text-xs py-3.5 shadow-lg shadow-slate-200"
                onClick={fetchCollections}
                loading={loading}
            />
        </div>
      </div>
    </div>
  );

  const customerBodyTemplate = (rowData) => {
    const isRetail = rowData.customerId === 0;
    return (
      <div
        className={`flex items-center ${isRetail ? '' : 'cursor-pointer hover:text-blue-600 transition-colors'}`}
        onClick={() => !isRetail && navigate(`/customers/detail/${rowData.customerId}`)}
      >
        <div className="w-1 h-7 rounded-full !bg-slate-100 flex items-center justify-center mr-2">
            <i className={`pi ${isRetail ? 'pi-shopping-bag !text-orange-500' : 'pi-user !text-blue-500'} text-[10px]`}></i>
        </div>
        <span className={`font-bold ${isRetail ? 'text-slate-500 italic' : 'text-slate-700'}`}>
          {rowData.customerName}
        </span>
      </div>
    );
  };

  const amountBodyTemplate = (rowData) => {
    return (
      <span className={`font-black ${rowData.amount < 0 ? 'text-red-600' : 'text-emerald-700'}`}>
        ₺{rowData.amount.toLocaleString('tr-TR', { minimumFractionDigits: 2 })}
      </span>
    );
  };

  const typeBodyTemplate = (rowData) => {
    const isAdjustment = rowData.paymentType === "Bakiye Düzeltme";
    return (
      <Tag
        value={rowData.paymentType}
        severity={isAdjustment ? "warning" : "success"}
        className="text-[10px] font-black uppercase px-2 py-0.5 rounded"
      />
    );
  };

  return (
    <div className="p-2 md:p-4 space-y-4 animate-fade-in">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="bg-white shadow-xl border border-slate-200 rounded-3xl overflow-hidden p-6">
        <DataTable
          value={collections}
          header={header}
          loading={loading}
          paginator
          rows={20}
          globalFilter={globalFilter}
          responsiveLayout="scroll"
          className="p-datatable-sm custom-table"
          rowClassName={() => 'hover:bg-slate-50/50 transition-colors'}
        >
          <Column field="date" header="TARİH" sortable className="text-[11px] font-bold text-slate-500 w-32" />
          <Column header="MÜŞTERİ" body={customerBodyTemplate} sortable field="customerName" className="text-sm" />
          <Column header="İŞLEM TİPİ" body={typeBodyTemplate} sortable field="paymentType" className="w-40" />
          <Column header="TUTAR" body={amountBodyTemplate} sortable field="amount" className="w-32" />
          <Column
            field="description"
            header="AÇIKLAMA / DETAY"
            body={(rowData) => (
                <div className="text-[11px] text-slate-500 font-medium max-w-[400px] whitespace-pre-wrap truncate hover:whitespace-normal transition-all">
                    {rowData.description}
                </div>
            )}
            className="text-sm"
          />
          <Column
            header="İŞLEM"
            body={(rowData) => (
              rowData.customerId !== 0 ? (
                <Button
                    icon="pi pi-external-link"
                    className="p-button-text p-button-info p-button-sm rounded-lg"
                    onClick={() => navigate(`/customers/detail/${rowData.customerId}`)}
                    tooltip="Müşteri Detayına Git"
                />
              ) : null
            )}
            className="w-20"
          />
        </DataTable>
      </div>

      <style jsx>{`
        .custom-table .p-datatable-header {
          background: transparent;
          border: none;
          padding: 0 0 1.5rem 0;
        }
        .custom-table .p-column-header-content {
          font-size: 10px;
          font-weight: 900;
          letter-spacing: 0.1em;
          color: #64748b;
          text-transform: uppercase;
        }
      `}</style>
    </div>
  );
}
